import React from 'react';

interface Props {
  indeterminate: string;
  checked?: boolean;
  id?: string;
  onClick?: () => void;
  onChange?: () => void;
}

const TreeCheckbox: React.FC<Props> = (props) => {
  return <input {...props} type="checkbox" />;
};

export default TreeCheckbox;
